import React from 'react';
import {Form, Select, Dropdown} from 'semantic-ui-react';
import Accesories from './Accesories';
import {getValidYears} from '../../utils';
import DatePicker from 'react-datepicker';
import NumberFormat from 'react-number-format';
import {MAXYEARS, ACTUALYEAR, PLAQUESOPTIONS, CITIES} from '../../constants';

const yearsValid = getValidYears(MAXYEARS, ACTUALYEAR);

const FormVehicle = ({
  vehicleState,
  handleInput,
  handleAddAccessory,
  handleDeleteAccessory,
  handleChangeDate,
  handleSelect,
  handleMilesInput,
  validateStatus,
  blockDate,
}) => {
  const {
    accessories,
    accessory,
    description,
    endSaleDate,
    priceSale,
    enrollment,
    km,
    digitPlaque,
    city,
  } = vehicleState;

  return (
    <Form>
      <div className="tcc-wrapper">
        <Form.TextArea
          disabled={validateStatus}
          name="description"
          value={description}
          onChange={handleInput}
          label="Descripción"
          placeholder="Describe como es tú vehículo..."
        />
        <Accesories
          validateStatus={validateStatus}
          accessories={accessories}
          accessory={accessory}
          handleInput={handleInput}
          handleAddAccessory={handleAddAccessory}
          handleDeleteAccessory={handleDeleteAccessory}
        ></Accesories>
        <Form.Group widths="equal">
          <Form.Input fluid label="Fecha de venta del concesionario al cliente">
            <DatePicker
              disabled={blockDate || validateStatus}
              placeholderText="Fecha venta cliente final"
              className="tcc-datepicker"
              showYearDropdown
              selected={endSaleDate}
              dateFormat="yyyy/MM/dd"
              onChange={handleChangeDate}
            />
          </Form.Input>

          <Form.Field>
            <label>Precio de venta al público</label>
            <NumberFormat
              name="priceSale"
              placeholder="Precio de venta al público"
              value={priceSale}
              thousandSeparator={true}
              prefix={'$ '}
              onValueChange={(event) => handleMilesInput(event, 'priceSale')}
              allowLeadingZeros={false}
              allowNegative={false}
            />
          </Form.Field>

          <Form.Field
            disabled={validateStatus}
            fluid
            name="enrollment"
            control={Select}
            options={yearsValid}
            value={enrollment}
            onChange={(e, {value}) => handleSelect(e, 'enrollment', value)}
            label="Año de la última matricula"
            placeholder="Año de la última matricula"
          />
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Field
            control={Dropdown}
            options={CITIES}
            onChange={(e, {value}) => handleSelect(e, 'city', value)}
            value={city}
            fluid
            search
            selection
            type="text"
            label="Ciudad"
            placeholder="Seleccione la ciudad"
          />

          <Form.Field
            disabled={validateStatus}
            control={Select}
            options={PLAQUESOPTIONS}
            onChange={(e, {value}) => handleSelect(e, 'digitPlaque', value)}
            value={digitPlaque}
            fluid
            label="Último digito de la placa"
            type="number"
            placeholder="Ultimo digito de la placa"
          />
          <Form.Field>
            <label>Kilometraje (km)</label>
            <NumberFormat
              placeholder="Kilometraje"
              value={km}
              thousandSeparator={true}
              onValueChange={(event) => handleMilesInput(event, 'km')}
            />
          </Form.Field>
        </Form.Group>
      </div>
    </Form>
  );
};

export default FormVehicle;
